import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_background, get_background_categories_data, update_background } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './backgroundform.css';

export const BackgroundForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
    const [backgrounds, setBackgrounds] = useState({
        name: state ? state.name : "",
        category: state ? state.category?._id : "",
        isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
        // isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    // console.log(state);
    const [imgObj, setImgObj] = useState({ backgroundPreviewDiy: state ? state.preview : "", backgroundImgDiy: state ? state.backgroundImg : "" });
    const [category, setCategory] = useState([]);

    const getCategoryAndTagFunc = async () => {
        try {
            const categoryData = await get_background_categories_data(1, "", "", { isActive: true });
            if (categoryData.status) {
                setCategory(categoryData.data);
            } else {
                toast.error(categoryData.message);
            }
        } catch (error) {
            console.error(error);
        };
    };

    const handleChange = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
        setBackgrounds({ ...backgrounds, [e.target.name]: e.target.value });
    };

    const handleFileInput = (e) => {
        if (e.target.files[0].size > 5242880) {
            toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
        } else {
            setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
            setBackgrounds({ ...backgrounds, [e.target.name]: e.target.files[0] });
        }
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: backgrounds[e.target.name] ? false : true });
        setBackgrounds({ ...backgrounds, [e.target.name]: backgrounds[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateBackgrounds;
        setIsLoading(true);
        if (state) {
            // console.log(backgrounds, "=========state.category._id=============");
            createUpdateBackgrounds = await update_background(updatedData, state._id)
        } else {
            // console.log("==========backgrounds==========", backgrounds);
            createUpdateBackgrounds = await add_background(backgrounds)
        }
        setIsLoading(false);
        if (createUpdateBackgrounds) {
            const { message, status } = createUpdateBackgrounds;
            if (status) {
                toast.success(message);
                navigate("/background");
                setBackgrounds({
                    name: "",
                    category: "",
                    isPremium: false,
                    // isActive: false,
                });
                setImgObj({ backgroundPreviewDiy: "", backgroundImgDiy: "" });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];

        // Object.keys(backgrounds).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (backgrounds[fieldName].toString().length > 0) {
        //             allFieldDone.push(true);
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });
        // if (!state) {
        //     Object.keys(imgObj).map(async (fieldName, i) => {
        //         if (!imgObj[fieldName]) {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //             return allFieldDone;
        //         } else {
        //             allFieldDone.push(true);
        //         }
        //     });
        // }

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateBackgrounds;
        //     setIsLoading(true);
        //     if (state) {
        //         // console.log(backgrounds, "=========state.category._id=============");
        //         createUpdateBackgrounds = await update_background(backgrounds, state._id)
        //     } else {
        //         // console.log("==========backgrounds==========", backgrounds);
        //         createUpdateBackgrounds = await add_background(backgrounds)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateBackgrounds) {
        //         const { message, status } = createUpdateBackgrounds;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/background");
        //             setBackgrounds({
        //                 id: "",
        //                 name: "",
        //                 category: "",
        //                 isPremium: false,
        //                 // isActive: false,
        //             });
        //             setImgObj({ backgroundPreviewDiy: "", backgroundImgDiy: "" });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        getCategoryAndTagFunc();
    }, []);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Background` : `Add Background`}</h3>
            </div>
            <Row>
                <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>Preview: </h6>
                            <img className='w-100' src={`${imgObj.backgroundPreviewDiy ? imgObj.backgroundPreviewDiy : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : backgrounds.name} />
                        </Col>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>BackgroundImg: </h6>
                            <img className='w-100' src={`${imgObj.backgroundImgDiy ? imgObj.backgroundImgDiy : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : backgrounds.name} />
                        </Col>
                    </Row>
                </Col>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='backgrounds_name' column md={3} sm={4}>Name</Form.Label>
                                <Col><Form.Control id='backgrounds_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : backgrounds.name} required /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='backgrounds_backgroundPreviewDiy' column md={3} sm={4}>Preview</Form.Label>
                                <Col><Form.Control id='backgrounds_backgroundPreviewDiy' type="file" accept='image/*' name='backgroundPreviewDiy' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='backgrounds_backgroundImgDiy' column md={3} sm={4}>BackgroundImg</Form.Label>
                                <Col><Form.Control id='backgrounds_backgroundImgDiy' type="file" accept='image/*' name='backgroundImgDiy' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='background_category' column md={3} sm={4}>Category</Form.Label>
                                <Col>
                                    <Form.Select name='category' onChange={handleChange} value={updatedData.category ? updatedData.category : backgrounds.category} required>
                                        <option value={""} className='text-muted'>Select Category</option>
                                        {category.map((_ele, i) => <option key={i} value={_ele._id}>{_ele.name}</option>)}
                                    </Form.Select>
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='backgrounds_isPremium' column md={3} sm={4}>Premium</Form.Label>
                                <Col><Form.Check type="switch" id="backgrounds_isPremium" name='isPremium' onChange={handleSwitch} checked={updatedData.isPremium ? updatedData.isPremium : backgrounds.isPremium} role="button" /></Col>
                            </Col>
                            {/* <Col lg={6} className="mb-3">
                                <Row className='align-items-center'>
                                    <Form.Label htmlFor='backgrounds_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="backgrounds_isActive" name='isActive' onChange={handleSwitch} checked={backgrounds.isActive} role="button" /></Col>
                                </Row>
                            </Col> */}
                        </Row>
                        <Row className='justify-content-start'>
                            <Col lg={12}>
                                    <Col lg={3} md={3} sm={4}></Col>
                                    <Col>
                                        <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                        </Button>
                                        {/* <Link to=""> */}
                                        <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                        {/* </Link> */}
                                    </Col>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

BackgroundForm.defaultProps = {
    title: "Background Form"
};

export default BackgroundForm;